import { creators } from '@/mocks/home';

export default function CreatorEcosystem() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">创作者生态</h2>
          <p className="text-sm text-foreground-500 mt-2">与优秀创作者一起，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {creators.map((creator) => (
            <div
              key={creator.name}
              className="group bg-background-100 rounded-lg p-5 md:p-6 text-center transition-transform duration-200 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-20 h-20 md:w-24 md:h-24 mx-auto mb-4">
                <img
                  src={creator.avatar}
                  alt={creator.name}
                  className="w-full h-full rounded-full object-cover object-top"
                  title={`${creator.name} - 蜜桃传媒创作者`}
                />
                {creator.verified && (
                  <span className="absolute -bottom-0.5 -right-0.5 w-6 h-6 bg-accent-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-background-50 text-xs" />
                  </span>
                )}
              </div>
              <h3 className="text-base font-semibold text-foreground-900">{creator.name}</h3>
              <p className="text-xs text-foreground-500 mt-1 mb-3">{creator.title}</p>
              <div className="flex items-center justify-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-user-follow-line text-xs" />
                  {creator.followers}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-file-text-line text-xs" />
                  {creator.works} 作品
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}